<template>
  <main class="main">
    <Hero />
    <Ticker />
    <Company />
    <Services />
    <Projects />
    <Contact />
  </main>
</template>

<script>
import Hero from '@/components/home/Hero'
import Ticker from '@/components/home/Ticker'
import Company from '@/components/home/Company'
import Services from '@/components/home/Services'
import Projects from '@/components/home/Projects'
import Contact from '@/components/home/Contact'

export default {
  name: 'HomePage',
  components: {
    Hero,
    Ticker,
    Company,
    Services,
    Projects,
    Contact
  },
  metaInfo() {
    return {
      title: this.$route.meta.title,
      meta: [{ vmid: 'description', name: 'description', content: this.$route.meta.description }]
    }
  }
}
</script>
